const transitions = {
  defaultTransition: "all 0.5s ease",
  cardHover: "box-shadow 0.2s ease-out, transform 0.3s ease-in-out",
  background: "background 0.5s ease",
};

export default transitions;
